// keyboard-adjust.directive.ts
import {Directive, ElementRef, NgZone, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {Keyboard, KeyboardResize, KeyboardResizeOptions} from '@capacitor/keyboard';
import {Capacitor} from '@capacitor/core';

@Directive({
    selector: '[keyboardScroll]'
})
export class KeyboardScrollDirective implements OnInit, OnDestroy {
    private keyboardHeight = 0;

    private resizeOptions: KeyboardResizeOptions;

    constructor(
        private el: ElementRef<HTMLElement>,
        private renderer: Renderer2,
        private ngZone: NgZone
    ) {
    }

    async ngOnInit(): Promise<void> {
        if (!Capacitor.isPluginAvailable('Keyboard')) {
            return Promise.resolve();
        }

        await Keyboard.setScroll({isDisabled: true});
        this.resizeOptions = await Keyboard.getResizeMode();
        await Keyboard.setResizeMode({
            mode: KeyboardResize.None
        });

        await Keyboard.addListener('keyboardWillShow', (info: any) => {
            this.ngZone.run(() => {
                this.keyboardHeight = info.keyboardHeight;
                this.renderer.setStyle(this.el.nativeElement, 'transition', 'margin-bottom 0.3s ease');
                this.renderer.setStyle(this.el.nativeElement, 'margin-bottom', `${this.keyboardHeight}px`);
            });
        });
        await Keyboard.addListener('keyboardWillHide', () => {
            this.ngZone.run(() => {
                this.renderer.setStyle(this.el.nativeElement, 'margin-bottom', '0px');
            });
        });
    }

    async ngOnDestroy(): Promise<void> {
        if (!Capacitor.isPluginAvailable('Keyboard')) {
            return Promise.resolve();
        }

        await Keyboard.removeAllListeners(); // Clean up
        await Keyboard.setResizeMode(this.resizeOptions);
    }
}
